class ChatAPIService {
    constructor() {
        
        if (new.target === ChatAPIService) {
            throw new Error("Cannot instantiate an abstract class.");
        }
        if (this.chatCompletion === ChatAPIService.prototype.chatCompletion) {
            throw new Error("Class extending UserAPIService must override 'chatCompletion(data)'.");
        }
        if (this.initChat === ChatAPIService.prototype.initChat) {
            throw new Error("Class extending UserAPIService must override 'initChat(data)'.");
        }
        if (this.getMessages === ChatAPIService.prototype.getMessages) {
            throw new Error("Class extending UserAPIService must override 'getMessages({ chatChannelId, skip, limit })'.");
        }
        if (this.startVideoCall === ChatAPIService.prototype.startVideoCall) {
            throw new Error("Class extending UserAPIService must override 'startVideoCall(data)'.");
        }
        if (this.endVideoCall === ChatAPIService.prototype.endVideoCall) {
            throw new Error("Class extending UserAPIService must override 'endVideoCall(data)'.");
        }
        if (this.startVoiceCall === ChatAPIService.prototype.startVoiceCall) {
            throw new Error("Class extending UserAPIService must override 'startVoiceCall(data)'.");
        }
        if (this.endVoiceCall === ChatAPIService.prototype.endVoiceCall) {
            throw new Error("Class extending UserAPIService must override 'endVoiceCall(data)'.");
        }
        if (this.clearChat === ChatAPIService.prototype.clearChat) {
            throw new Error("Class extending UserAPIService must override 'endVoiceCall(data)'.");
        }
    }

    async initChat(data) {
        throw new Error("Method 'initChat(data)' must be implemented.");
    }

    async getMessages({ chatChannelId, skip, limit }) {
        throw new Error("Method 'getMessages({ chatChannelId, skip, limit })' must be implemented.");
    }

    async chatCompletion(data) {
        throw new Error("Method 'chatCompletion(data)' must be implemented.");
    }

    async startVideoCall(data) {
        throw new Error("Method 'startVideoCall(data)' must be implemented.");
    }

    async endVideoCall(data) {
        throw new Error("Method 'endVideoCall(data)' must be implemented.");
    }

    async startVoiceCall(data) {
        throw new Error("Method 'startVoiceCall(data)' must be implemented.");
    }

    async endVoiceCall(data) {
        throw new Error("Method 'endVoiceCall(data)' must be implemented.");
    }

    async clearChat(chatChannelId) {
        throw new Error("Method 'clearChat' must be  implemented");
    }
}

export default ChatAPIService;